import type { VibeCardData } from "@/pages/vibeLab/types";

export const mockVibeProjects: Array<VibeCardData> = [
  {
    id: "1",
    appName: "wa-link-generator",
    category: "Redirect Link",
    status: "External-use",
    externalUrl: "https://solutions.cresclab.com/whatsapp-link-generator",
    aiStudioUrl: "",
    description: "快速生成帶有 UTM 參數的 WhatsApp 連結",
    tags: ["WA", "Redirect"],
    updatedAt: "2026-02-02",
  },
];
